import type { Permission } from '@repo/contracts';

import { APP_ROUTES } from '@/constants/app-routes';

/**
 * The one rule for where a role lands. Every role lands on the home page, which
 * needs only a session, so a guard that turns a page away can always send the
 * person there without looping.
 */
export const homeRouteFor = (_permissions: readonly Permission[]): string => APP_ROUTES.home;
